module.exports = __webpack_public_path__ + "heart-classic.fc491e8ab501ad80cfb7.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/heart-classic.svg
// module id = ../../../../../src/assets/img/heart-classic.svg
// module chunks = main